import styled from '@emotion/styled'

// Select mirrors Input's tokenized field styling, with a custom chevron so the
// control reads consistently across browsers. It stays a native <select> for
// full keyboard + screen-reader support (KAT-297 WCAG AA).
export const Select = styled.select`
  appearance: none;
  background: var(--c-bg-elev)
    url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'><path d='M2 4l4 4 4-4' stroke='%23999' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>")
    no-repeat right 12px center;
  color: var(--c-fg);
  border: 1px solid var(--c-border);
  border-radius: var(--r-md);
  padding: 10px 34px 10px 12px;
  font-family: var(--font-sans);
  font-size: 14px;
  width: 100%;
  cursor: pointer;
  transition: border-color var(--d-fast) var(--ease-standard);

  &:focus {
    outline: none;
    border-color: var(--c-accent);
    box-shadow: 0 0 0 3px var(--c-accent-soft);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
